import PollIcon from '@mui/icons-material/Poll';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import FeedbackIcon from '@mui/icons-material/Feedback';
import QuizIcon from '@mui/icons-material/Quiz';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import AssignmentIcon from '@mui/icons-material/Assignment';
import iconModal    from '../../../assets/images/editor/type-modal.svg';
import iconSlider   from '../../../assets/images/editor/type-slider.svg';
import iconTakeover from '../../../assets/images/editor/type-takeover.svg';
import iconInline   from '../../../assets/images/editor/type-inline.svg';

// ─── Form Goal Icons ──────────────────────────────────────────────────────────
// Keyed by FORM_GOALS[].key — used in both the interstitial and editor step.
export const FORM_GOAL_ICONS = {
  survey:   AssignmentIcon,
  poll:     PollIcon,
  lead_gen: PersonAddIcon,
  feedback: FeedbackIcon,
  quiz:     QuizIcon,
  contact:  ContactMailIcon,
};

// ─── Form Layout Metadata ─────────────────────────────────────────────────────
// Used in FormLayout (editor step) and FormLayoutSelection (interstitial).

export const FORM_LAYOUT_META = {
  Modal:    { icon: iconModal,    description: 'Centered popup overlay. Best for multi-field forms.',         recommended: true },
  Slider:   { icon: iconSlider,   description: 'Slides in from the corner. Less intrusive, still effective.' },
  Inline:   { icon: iconInline,   description: 'Embed directly in your page content.' },
  Takeover: { icon: iconTakeover, description: 'Full-screen form. Highest engagement for important surveys.' },
};

// ─── Form Field Catalogue ─────────────────────────────────────────────────────
// Single source of truth for all supported field types.
// Add new field types here — FormBuilderPanel and the script both derive from this.
export const FORM_FIELD_CATALOGUE = [
  {
    id: 'basic',
    label: 'BASIC',
    fields: [
      { type: 'short_text',   label: 'Short Text', icon: '✏',  defaults: { label: 'Short Answer',   placeholder: 'Your answer' } },
      { type: 'long_text',    label: 'Long Text',  icon: '¶',  defaults: { label: 'Long Answer',    placeholder: 'Describe in detail…' } },
      { type: 'number',       label: 'Number',     icon: '#',  defaults: { label: 'Number',         placeholder: '0' } },
      { type: 'email',        label: 'Email',      icon: '@',  defaults: { label: 'Email Address',  placeholder: 'you@example.com' } },
      { type: 'phone',        label: 'Phone',      icon: '☎',  defaults: { label: 'Phone Number',   placeholder: '+1 (555) 000-0000' } },
      { type: 'full_name',    label: 'Full Name',  icon: 'N',  defaults: { label: 'Full Name',      placeholder: 'Your full name' } },
    ],
  },
  {
    id: 'choice',
    label: 'CHOICE',
    fields: [
      { type: 'dropdown',        label: 'Dropdown',      icon: '▾', defaults: { label: 'Choose one',            options_json: '["Option A","Option B","Option C"]' } },
      { type: 'single_choice',   label: 'Single Choice', icon: '◉', defaults: { label: 'Pick one',              options_json: '["Option A","Option B"]' } },
      { type: 'multiple_choice', label: 'Multi Choice',  icon: '☑', defaults: { label: 'Select all that apply', options_json: '["Option A","Option B","Option C"]' } },
      { type: 'yes_no',          label: 'Yes / No',      icon: '✓', defaults: { label: 'Would you recommend us?' } },
      { type: 'rating',          label: 'Rating',        icon: '★', defaults: { label: 'Rate your experience', scale_min: 1, scale_max: 5 } },
    ],
  },
  {
    id: 'advanced',
    label: 'ADVANCED',
    fields: [
      { type: 'address',      label: 'Address',     icon: '⌖', defaults: { label: 'Address',             placeholder: 'Street, City, State' } },
      { type: 'date',         label: 'Date',        icon: '▦', defaults: { label: 'Date' } },
      { type: 'rating_scale', label: 'Scale',       icon: '↔', defaults: { label: 'On a scale of 1–10…', scale_min: 1, scale_max: 10, scale_min_label: 'Poor', scale_max_label: 'Excellent' } },
      { type: 'heading',      label: 'Heading',     icon: 'H', defaults: { label: 'Section Heading' } },
      { type: 'paragraph',    label: 'Paragraph',   icon: '≡', defaults: { label: 'Instructions or description text' } },
    ],
  },
];
